import { useRouter } from 'react-resource-router';

import traceUFOTransition from '@atlaskit/react-ufo/trace-transition';

import { getPageLoadType } from '../performance-metrics/get-page-load-type';

import { getUFOName } from './getUFOName';

export const useReactUFOWatcher = (): void => {
  const [routerState] = useRouter();
  const { route, action } = routerState;
  const pageLoadType = getPageLoadType();
  if (route.name && pageLoadType !== 'full_page' && action !== 'REPLACE') {
    const ufoName = getUFOName(route);
    // Ignore REPLACE actions because they are redirects
    traceUFOTransition(ufoName, route.name);
  }
};
